import React, { Component } from 'react';

import FileNavigator from '../FileNavigator/FileNavigator.react';
import ncConnector from '../../../../s3-connector';
import getMess from '../../../../s3-connector/translations';
import { propTypes } from './props-description';
import { apiOptions } from '../../../../../../shared/constants/apiOptions';
import { ItemTypes } from '../../../../constants/constants';

import { Modal } from 'antd';

import './MoveToDialog.less';

export default class MoveToDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      valid: true,
      selection: null,
      resourceLocation: null,
    };
  }

  handleSubmitButtonClick = async (e) => {
    await this.props.onSubmit(this.state.selection[0] || this.state.resourceLocation[this.state.resourceLocation.length - 1].id);
  };

  listViewLayout = (viewLayoutOptions) => {
    const getMessage = getMess.bind(null, viewLayoutOptions.locale);
    return [
      {
        elementType: 'Column',
        elementProps: {
          key: 'name',
          dataKey: 'name',
          width: 48,
          label: getMessage('title'),
          flexGrow: 1,
          cellRenderer: {
            elementType: 'NameCell',
            callArguments: [viewLayoutOptions],
          },
          headerRenderer: {
            elementType: 'HeaderCell',
            callArguments: [viewLayoutOptions],
          },
          disableSort: false,
        },
      },
    ];
  };

  onSelectionChange = async (selection) => {
    const isValid = await this.props.onValidate(selection);
    this.setState({ selection, valid: isValid });
  };

  onResourceLocationChange = async (resourceLocation) => {
    const isValid = await this.props.onValidate(this.state.selection, resourceLocation);
    this.setState({ resourceLocation, valid: isValid });
  };

  filterResourceChildren = (resourceChildren) =>
    resourceChildren.type === ItemTypes.Directory && !this.props.movableFiles.some((x) => x.id === resourceChildren.id);

  render() {
    const {
      onHide,
      headerText,
      submitButtonTextWithoutSelectedFolder,
      submitButtonTextWithSelectedFolder,
      cancelButtonText,
      movableFiles,
      rootContainer,
      controlConfiguration,
    } = this.props;
    const { valid } = this.state;

    return (
      <Modal
        title={headerText}
        getContainer={rootContainer}
        open={true}
        onCancel={onHide}
        okText={this.state.selection && this.state.selection.length ? submitButtonTextWithSelectedFolder : submitButtonTextWithoutSelectedFolder}
        okButtonProps={{
          disabled: !valid,
        }}
        cancelText={cancelButtonText}
        onOk={() => this.handleSubmitButtonClick()}
      >
        <FileNavigator
          id="filemanager-2"
          api={ncConnector.api}
          apiOptions={{ ...apiOptions, ...ncConnector.apiOptions }}
          listViewLayout={this.listViewLayout}
          viewLayoutOptions={ncConnector.viewLayoutOptions}
          disableToolbar={true}
          controlConfiguration={controlConfiguration}
          onSelectionChange={this.onSelectionChange}
          filterResourceChildren={this.filterResourceChildren}
          onResourceLocationChange={this.onResourceLocationChange}
          // disabling default behavior of navigator in this case
          onClickOutside={null}
          rootContainer={rootContainer}
        />
      </Modal>
    );
  }
}

MoveToDialog.propTypes = propTypes;
